import { ApolloError, gql, useQuery } from '@apollo/client';
import { type User, userFields } from '@domain/index';

export const meQuery = gql`
  query Me {
    me {
      ${userFields}
    }
  }
`;

interface Query {
  me: User;
}

interface UseMe {
  loading: boolean;
  error?: ApolloError;
  me?: User;
}

export const useMe = (): UseMe => {
  const { data, loading, error } = useQuery<Query>(meQuery);
  return { me: data?.me, loading, error };
};
